import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { environment } from "../../environments/environment";
import { TokenModel } from "../Models/tokenModel.model";
import { RequestModel } from "../Models/requestModel.model";
import { Router } from "@angular/router";
import { EmployeeModel } from "../Models/EmpCareerUser.model";
import { EmployeeService } from "../views/employee-profile/employee-profile.service";
const helper = new JwtHelperService();

@Injectable({
  providedIn: "root",
})
export class AuthServiceService {
  httpOptions = {
    headers: new HttpHeaders({
      Accept: "application/json",
    }),
  };
  private ApiUrl = environment.apiUrl;
  private Ecp_apiUrl = environment.apiUrl;
  private role: string;
  private downloadAndMail: boolean;
  private oragnizationId: string;
  private organizationName: string;
  private emailId: string;
  private employeeId: Number;
  public showFilterDemo: boolean;
  public showDemo: boolean;
  public demo = new Subject();
  employee: any;
  loading: boolean;

  constructor(private http: HttpClient, private route: Router, private employeeService: EmployeeService) { }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem("token");
    // Check whether the token is expired and return
    // true or false

    if (token !== null && !helper.isTokenExpired(token)) {
      if (this.role === undefined) {
        const jWTtoken = helper.decodeToken(token);
        this.role = jWTtoken.role;
      }

      return true;
    } else {
      return false;
    }
  }

  public isAuthorizedUser(authorizedRoles) {
    var authorizeduser = false;
    if (!authorizedRoles) return true;
    var userRoles = this.getRole();
    authorizedRoles.forEach((x) => {
      if (userRoles.indexOf(x) >= 0) authorizeduser = true;
    });
    return authorizeduser;
  }
  public requestAccess(request: RequestModel) {
    const url = this.ApiUrl + "User/RequestAccess";
    return this.http.put(url, request, {
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
      observe: "response",
    });
  }
  public getSSOToken() {
    const url = environment.ssoUrl;
    return this.http.get<any>(url, {
      headers: new HttpHeaders({ Accept: "application/json" }),
      observe: "response",
    });
  }

  public getToken(sso_token: any): Observable<any> {
    const url = this.ApiUrl + "token/GetToken";

    return this.http.post<any>(url, sso_token, {

      headers: new HttpHeaders({ Accept: 'application/json' }),

      observe: 'response'
    });
  }

  public getRole(): string {
    if (this.role === undefined) {
      const token = localStorage.getItem("token");
      if (token) {
        const jWTtoken = helper.decodeToken(token);
        this.role = jWTtoken.role;
      } else {
        this.route.navigate(["/login"]);
      }
    }
    return this.role;
  }

  public getDownloadAndMailRestriction(): boolean {
    if (this.downloadAndMail === undefined) {
      const token = localStorage.getItem("token");
      const jWTtoken = helper.decodeToken(token);
      if (
        jWTtoken.DownloadAndMailRestriction === "True" ||
        jWTtoken.DownloadAndMailRestriction === "true" ||
        jWTtoken.DownloadAndMailRestriction === "TRUE"
      ) {
        this.downloadAndMail = false;
      } else {
        this.downloadAndMail = true;
      }
    }
    return this.downloadAndMail;
  }

  public getOrganizationId(): string {
    if (this.oragnizationId === undefined) {
      const token = localStorage.getItem("token");
      const jWTtoken = helper.decodeToken(token);
      this.oragnizationId = jWTtoken.OrganizationId;
    }
    return this.oragnizationId;
  }
  public getOrganizationName(): string {
    if (this.organizationName === undefined) {
      const token = localStorage.getItem("token");
      const jWTtoken = helper.decodeToken(token);
      this.organizationName = jWTtoken.organizationName;
    }
    return this.organizationName;
  }
  public getEmailId(): string {
    if (this.emailId === undefined) {
      const token = localStorage.getItem("token");
      const jWTtoken = helper.decodeToken(token);
      this.emailId = jWTtoken?.email;
    }
    return this.emailId;
  }
  public getEmployeeId() {
    if (this.employeeId === undefined) {
      const token = localStorage.getItem("token");
      const jWTtoken = helper.decodeToken(token);
      this.employeeId = jWTtoken.Id;
    }
    return this.employeeId;
  }

  public setLocalstorage(value: TokenModel, SSOtoken: string) {
    let redirectTo = localStorage.getItem("redirectTo")
    localStorage.clear();

    if (redirectTo) localStorage.setItem("redirectTo", redirectTo);

    const jWTtoken = helper.decodeToken(value.accessToken);
    this.role = jWTtoken.role;
    this.showDemo = value.firstTimeLogin;
    this.showFilterDemo = value.firstTimeLogin;
    localStorage.setItem("role", jWTtoken.role);
    localStorage.setItem("Id", jWTtoken.Id);
    localStorage.setItem("email", jWTtoken.email);
    localStorage.setItem("token", value.accessToken);
    localStorage.setItem("client", jWTtoken.client);
    localStorage.setItem("organizationId", jWTtoken.OrganizationId);
    localStorage.setItem("organizationName", jWTtoken.organizationName);
    if(jWTtoken.TimesheetAccess == "true"){
      localStorage.setItem("timesheetManager",jWTtoken.TimesheetAccess);
    }
    else{
      localStorage.setItem("timesheetManager","false");
    }
    if (SSOtoken) {
      localStorage.setItem('SSOtoken', SSOtoken)
    }
  }

  public getEmpCareerUserInfo(EmpId: Number): Observable<EmployeeModel> {
    return this.http.get<EmployeeModel>(`${this.Ecp_apiUrl}ECPUser/GetUserInfo?EmployeeId=${EmpId}`)
  }
  // getEmployeeDetails(empId?: number) {
  //   if (empId) {
  //     this.loading = true;
  //     this.employeeService.getEmployeeDetails(empId).subscribe(
  //       (res) => {
  //         this.employee = res.data;
  //         this.loading = false;
  //         localStorage.setItem('firstName',this.employee.firstName)
  //       localStorage.setItem('lastName',this.employee.lastName)
  //       },
  //       (error) => {
  //         console.error('Error fetching employee details:', error);
  //         this.loading = false;
  //       }
  //     );
  //   }
  // }
}
